import React from 'react';
import Card from '../card';
import ConfigProvider from '../config-provider';

class Box extends React.Component {
  render() {
    return (
      <Card isBox contentHeight="auto" showHeadDivider {...this.props} />
    );
  }
}

export default ConfigProvider.config(Box);
